import { render, staticRenderFns } from "./SangomaAIAssistanceButton.vue?vue&type=template&id=36afb434&"
import script from "./SangomaAIAssistanceButton.vue?vue&type=script&lang=js&"
export * from "./SangomaAIAssistanceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports